import { makeObservable, observable, action } from "mobx";
import { Search } from "../../api/Types";

export default class Searcher {
  search: Search = {
    text: "",
    fieldNames: [],
    allTextFields: false,
  };

  constructor(fieldNames: Array<string> = ["Text", "Name", "Title", "Address"], allTextFields = false) {
    this.search.fieldNames = fieldNames;
    this.search.allTextFields = allTextFields;

    makeObservable(this, {
      search: observable,
      setText: action,
    });
  }

  setText(newValue: string): void {
    this.search.text = newValue;
  }

  getText(): string {
    return this.search.text;
  }

  getSearch(): Search {
    return this.search;
  }
}
